module.exports = __webpack_public_path__ + "static/img/hero_preview.6e1753b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/hero_preview.png
// module id = 0imi
// module chunks = 0